import { InfoCircleFilledIcon, Tooltip } from '@/components';
import type { FC, ReactNode } from 'react';
import { SvgIcon } from './SvgIcon';

type Props = {
  hint: ReactNode;
};

export const HintIcon: FC<Props> = ({ hint }) => {
  if (typeof hint === 'string' && hint.trim() === '') {
    return null;
  }

  return (
    <Tooltip title={hint}>
      <SvgIcon size={16} component={InfoCircleFilledIcon} />
    </Tooltip>
  );
};
